export default class QaiScorecardChallengeQuestionsViewModel {
    public pageCount: number | null = null
    public questions: QaiScorecardChallengeQuestionViewModel[] = []
}

export class QaiScorecardChallengeQuestionViewModel {
    client: string
    questionId: number
    sectionId: number
    templateId: number
    aiTemplateVersion: number
    templateName: string
    sectionTitle: string
    questionText: string
    challengeCount: number
    state: string
}